"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _brightDates = require("bright-dates");

var _pad = _interopRequireDefault(require("../../utils/pad"));

var _Input = _interopRequireDefault(require("../Input"));

var _Select = _interopRequireDefault(require("../Select"));

var _Option = _interopRequireDefault(require("../Select/Option"));

var _months = _interopRequireDefault(require("./months.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\twhite-space: nowrap;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 90px !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 60px !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DayInput = (0, _styledComponents.default)(_Input.default)(_templateObject());
DayInput.displayName = 'DayInput';
var YearInput = (0, _styledComponents.default)(_Input.default)(_templateObject2());
YearInput.displayName = 'YearInput';

var Container = _styledComponents.default.span(_templateObject3());

Container.displayName = 'Container';

var DateInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DateInput, _Component);

  function DateInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    var value = _this.props.value;

    var _date = value ? (0, _brightDates.date)(value) : false;

    _this.state = {
      day: _date ? _date.date() : '',
      month: _date ? _date.month() + 1 : '',
      year: _date ? _date.year() : '',
      value: value
    };
    return _this;
  } // eslint-disable-next-line camelcase


  var _proto = DateInput.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== '' && nextProps.value !== this.state.value) {
      var _date = (0, _brightDates.date)(nextProps.value);

      this.setState({
        value: nextProps.value,
        day: _date.date(),
        month: _date.month() + 1,
        year: _date.year()
      });
    }
  };

  _proto.onChange = function onChange(e) {
    var _objectSpread2,
        _this2 = this;

    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    var type = e.type;

    var nextState = _objectSpread({}, this.state, (_objectSpread2 = {}, _objectSpread2[name] = +value, _objectSpread2));

    var day = nextState.day,
        month = nextState.month,
        year = nextState.year;
    var dateStr = year + "-" + (0, _pad.default)(month) + "-" + (0, _pad.default)(day);
    var isDateValid = (0, _brightDates.date)(dateStr).isValid();
    var isAnyFieldFilledIn = day || month || year;
    var isFilled = day > 0 && month > 0 && year > 1000;
    var returnValue = '';

    if (isFilled && isDateValid) {
      returnValue = dateStr;
    } else if (isAnyFieldFilledIn && !isFilled) {
      returnValue = false;
    }

    if (type === 'change') {
      var _this$setState;

      this.setState((_this$setState = {}, _this$setState[name] = value ? +value : '', _this$setState.value = dateStr, _this$setState), function () {
        _this2.props.onChange({
          name: _this2.props.name,
          value: returnValue
        });
      });
    } else if (this.props.onBlur) {
      this.props.onBlur({
        target: {
          name: this.props.name,
          value: returnValue
        }
      });
    }
  };

  _proto.render = function render() {
    var _this$state = this.state,
        day = _this$state.day,
        month = _this$state.month,
        year = _this$state.year;

    var _this$props = this.props,
        minYear = _this$props.minYear,
        maxYear = _this$props.maxYear,
        id = _this$props.id,
        name = _this$props.name,
        gaAction = _this$props.gaAction,
        gaTrackValue = _this$props.gaTrackValue,
        props = _objectWithoutPropertiesLoose(_this$props, ["minYear", "maxYear", "id", "name", "gaAction", "gaTrackValue"]);

    return _react.default.createElement(Container, {
      "data-e2e": "date-input-component-" + id
    }, _react.default.createElement(DayInput, _extends({}, props, {
      id: id,
      name: "day",
      value: day,
      onChange: this.onChange,
      onBlur: this.onChange,
      placeholder: "DD",
      type: "number",
      min: "1",
      max: "31",
      "data-track-action": gaAction + " day",
      "data-track-value": gaTrackValue ? 'on' : 'off'
    })), "\xA0", _react.default.createElement(_Select.default, _extends({}, props, {
      name: "month",
      value: month,
      onChange: this.onChange,
      onBlur: this.onChange,
      placeholder: "MM",
      type: "number",
      min: "1",
      max: "12",
      gaAction: gaAction + " month",
      gaTrackValue: gaTrackValue
    }), _months.default.map(function (_ref) {
      var label = _ref.label,
          value = _ref.value;
      return _react.default.createElement(_Option.default, {
        key: label,
        value: value
      }, label);
    })), "\xA0", _react.default.createElement(YearInput, _extends({}, props, {
      name: "year",
      value: year,
      onChange: this.onChange,
      onBlur: this.onChange,
      placeholder: "YYYY",
      type: "number",
      max: maxYear,
      min: minYear,
      "data-track-action": gaAction + " year",
      "data-track-value": gaTrackValue ? 'on' : 'off'
    })));
  };

  return DateInput;
}(_react.Component);

DateInput.displayName = 'DateInput';
DateInput.propTypes = {
  minYear: _propTypes.number,
  maxYear: _propTypes.number,
  onChange: _propTypes.func.isRequired,
  onBlur: _propTypes.func,
  value: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  id: _propTypes.string,
  gaAction: _propTypes.string,
  gaTrackValue: _propTypes.bool
};
DateInput.defaultProps = {
  gaAction: '',
  onBlur: undefined,
  id: '',
  minYear: 1900,
  maxYear: 3000,
  gaTrackValue: false
};
var _default = DateInput;
exports.default = _default;